export default __webpack_public_path__ + "static/media/mockup-update1.4e1ee7da.png";